const SUBSUB_TIME_MENU_ACTIONS = [
    { label: 'Zero-out', action: { type: 'set', value: 0 } },
    { label: '+1', action: { type: 'delta', value: 0.5 } },
    { label: '+2', action: { type: 'delta', value: 1.0 } }
]

export const buildSubsubContextMenuItems = ({ onMarkDone, onAdjustTime }) => {
    const doneItem = {
        label: 'Done',
        onClick: async (e) => {
            if (onMarkDone) {
                await onMarkDone()
            }
            e.preventDefault()
        }
    }

    const adjustItems = SUBSUB_TIME_MENU_ACTIONS.map((item) => ({
        label: item.label,
        onClick: async (e) => {
            if (onAdjustTime) {
                await onAdjustTime(item.action)
            }
            e.preventDefault()
        }
    }))

    return [doneItem, ...adjustItems]
}

